<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-shape`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M41.778 4C43.005 4 44 4.995 44 6.222v25.162l-4-6.762V8H8v32h4v4H6.222A2.222 2.222 0 014 41.778V6.222C4 4.995 4.995 4 6.222 4h35.556zM31.515 18.216a2 2 0 01.708.708l13 22.06A2 2 0 0143.5 44h-26a2 2 0 01-1.723-3.015l13-22.061a2 2 0 012.738-.708zM30.5 23.88L21 40h19l-9.5-16.121z"/></svg>
</template>
<script>

export default {
  name: 'IconShape',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
